<div class="parent-container"
  [@fadeInOutHidden]='!disabled'>
  <div class="main-form-row">
    @if (questionText || toolTipNames || labelText || questionParagraph) {
      <div class="label-container"
        >
        <div class="question-description label-tooltip-container">
          @if (questionText) {
            <label
              class="question-title one-form-question"
              [for]="getIdText('day')">
              {{questionText}}
            </label>
          }
          @if (labelText) {
            <label
              [for]="getIdText('day')"
            class="one-form-question-label">{{labelText}}</label>
          }
          @if (toolTipNames) {
            <app-tooltip
              [tooltipNames]='toolTipNames'
            toolTipId='dob_question'></app-tooltip>
          }
        </div>
        @if (questionParagraph) {
          <p class="question-paragraph"
          >{{questionParagraph}}</p>
        }
      </div>
    }

    <div class="option-container">
      <form [formGroup]="dateForm">
        <div class="select-date-container">
          <select class="one-dropdown"
            (change)="onDayChange($event)"
            [ngClass]="{'data-hj-suppress': addHotJarSuppressionTag()}"
            (blur)="onSelectBlur()"
            [id]="getIdText('day')"
            aria-label="Date of birth day"
            formControlName="day">
            <option value="null"
              disabled
            hidden>DD</option>
            @for (option of optionsList()?.monthDay; track option) {
              <option
                [ngValue]="option.code">{{option.value}}
              </option>
            }
          </select>
          <select class="one-dropdown"
            [ngClass]="{'data-hj-suppress': addHotJarSuppressionTag()}"
            (change)="onDayChange($event)"
            (blur)="onSelectBlur()"
            [id]="getIdText('month')"
            aria-label="Date of birth month"
            formControlName="month">
            <option value="null"
              disabled
            hidden>MM</option>
            @for (option of optionsList()?.month; track option) {
              <option
                [ngValue]="option.code">{{option.value}}
              </option>
            }
          </select>
          <select class="one-dropdown"
            [ngClass]="{'data-hj-suppress': addHotJarSuppressionTag()}"
            (change)="onDayChange($event)"
            (blur)="onSelectBlur()"
            [id]="getIdText('year')"
            aria-label="Date of birth year"
            formControlName="year">
            <option value="null"
              disabled
            hidden>YYYY</option>
            @for (option of optionsList()?.dobYear; track option) {
              <option
                [ngValue]="option.code">{{option.value}}
              </option>
            }
          </select>
        </div>
      </form>
    </div>
    <div class="col-md-1 offset-lg-2 text-right">
      @if (toolTipNames) {
        <app-tooltip
          [tooltipNames]='toolTipNames'>
        </app-tooltip>
      }
    </div>
  </div>
  @if (shouldShowError()) {
    <div class="row"
      [@fadeInOut]>
      <div class="col-12 text-left error-message-container  error-container-inline">
        <div class="error-msg-icon mt-2 d-md-inline"></div>
        <p class="error-text">
          {{getErrorMessage()}}
        </p>
      </div>
    </div>
  }
</div>